export default "__VITE_ASSET__D7R5BBT8__"